<template>
    <span>
        <v-tooltip :disabled="utils.isMobile()" :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    tag="a"
                    v-on="on"
                    class="link-menu"
                    :height="$vuetify.breakpoint.xs ? 30 : 46"
                    min-width="30"
                    :width="$vuetify.breakpoint.xs ? 30 : 50"
                    text
                    @click="darkMode"
                >
                    <v-icon v-if="!$vuetify.theme.dark" size="18px" color="black">mdi-weather-night</v-icon>
                    <v-icon v-else size="18px" color="yellow">mdi-white-balance-sunny</v-icon>
                </v-btn>
            </template>
            <span v-if="!$vuetify.theme.dark">{{ $t('dark.on') }}</span>
            <span v-else>{{ $t('dark.off') }}</span>
        </v-tooltip>
    </span>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menu-dark-switcher',
        components: {},

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },
        mounted() {},

        methods: {
            darkMode() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
                localStorage.setItem('isDark', this.$vuetify.theme.dark);
            },
        },
        computed: {},
    };
</script>
